import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class ReadingTask5Passage extends Vue {
  private _passage: [];
  private balaTasks: any;

  constructor() {
    super();
    this._passage = this.$store.getters.balaPassages.readingTask5;
    this.balaTasks = this.$store.getters.balaSections;
  }

  beforeCreate() {
    this._passage = this.$store.getters.balaPassages.readingTask5;
    this.balaTasks = this.$store.getters.balaSections;
  }

  render(h: CreateElement) {
    return (
      <Card title={this.balaTasks[5].name}>
        <div slot="mainContent">
          <v-list class="overflow-y-auto" max-height="340px">
            {this._passage.map((line, i) => (
              <v-list-item>
                <v-row>
                  <v-col cols="1">{i + 1}</v-col>
                  <v-col cols="11">
                    {this.$createElement("p", {
                      domProps: {
                        innerHTML: line
                      }
                    })}
                  </v-col>
                </v-row>
              </v-list-item>
            ))}
          </v-list>
        </div>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="secondary" to="understanding">
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = ReadingTask5Passage;
